import * as React from "react";

function SvgPlus(props) {
  return <svg width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}><path fill="currentColor" fillRule="evenodd" d="M7 1v3.98h4c1.33 0 1.33 2.03 0 2.03H7V11c0 1.33-2.02 1.33-2.02 0V7H1C-.33 7-.33 4.99 1 4.99h3.98V1C4.98-.33 7-.33 7 1z" clipRule="evenodd" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/plus_1b364e.svg";
export { SvgPlus as ReactComponent };